/* global google */
import { find, register } from '../../../Javascript/Utils.js'

const Map = el => {
  const mapElement = find(`.${el.dataset.componentprefix}map`, el)
  const markers = JSON.parse(el.dataset.markers)
  const center = JSON.parse(el.dataset.center)
  const zoom = parseInt(el.dataset.zoom, 10)
  const infoWindows = []
  const key = el.getAttribute('data-key')
  const language = el.getAttribute('data-language')
  const region = el.getAttribute('data-region')

  // google maps callback function
  window.googleMapsCallback = function googleMapsCallback () {
    const map = new google.maps.Map(mapElement, {
      mapId: key,
      center,
      zoom,
      streetViewControl: false,
      minZoom: 1,
      restriction: {
        latLngBounds: {
          north: 80,
          south: -80,
          east: 180,
          west: -180
        }
      }
    })
    for (const marker of markers) {
      const mapMarker = new google.maps.marker.AdvancedMarkerElement({
        position: marker,
        title: marker.title,
        map
      })

      const infoWindow = new google.maps.InfoWindow({
        content: `<b>${marker.title}</b><br />${marker.description.replace(/\n/, '<br />')}`
      })
      infoWindows.push(infoWindow)

      mapMarker.addListener('click', () => {
        for (const window of infoWindows) {
          window.close()
        }

        infoWindow.open({
          anchor: mapMarker,
          map,
          shouldFocus: false
        })
      })
    }
  }

  // load google script
  const scriptTag = document.createElement('script')
  scriptTag.src = 'https://maps.googleapis.com/maps/api/js?key=' + key + '&language=' + language + '&region=' + region + '&callback=googleMapsCallback&libraries=marker'
  el.appendChild(scriptTag)
}

register('Map', Map)
